import React, { FC, useEffect, useMemo } from "react";
import Glide from "@glidejs/glide";
import useNcId from "hooks/useNcId";
import { BannerType } from "data/types";

export interface SectionSliderBannerProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  subHeading?: string;
  banners: BannerType[];
  itemPerRow?: number;
  sliderStyle?: "style1" | "style2";
  uniqueClassName: string;
}

const SectionSliderBanner: FC<SectionSliderBannerProps> = ({
  heading = "",
  className = "",
  itemClassName = "",
  banners,
  itemPerRow = 1,
  sliderStyle = "style2",
  uniqueClassName,
}) => {
  const UNIQUE_CLASS = "SectionSliderNewCategories__" + uniqueClassName + useNcId();

  const MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      perView: itemPerRow,
      gap: 32,
      bound: true,
      autoplay: 3000,
      breakpoints: {
        1280: { perView: itemPerRow - 1 },
        1024: { gap: 20, perView: itemPerRow - 1 },
        768: { gap: 20, perView: itemPerRow - 2 },
        640: { gap: 20, perView: itemPerRow - 3 },
        500: { gap: 20, perView: 1.3 },
      },
    });
  }, [UNIQUE_CLASS]);

  useEffect(() => {
    if (MY_GLIDEJS && MY_GLIDEJS.mount) {
      setTimeout(() => {
        MY_GLIDEJS.mount();
      }, 100);
    }
  }, [MY_GLIDEJS]);

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {banners.map((item, index) => (
              <li key={index} className={`glide__slide ${itemClassName}`}>
                <div className="relative aspect-w-1 aspect-h-1 sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-16 lg:aspect-h-9 xl:aspect-h-8 ">
                  <img
                    className="absolute inset-0 object-cover rounded-xl"
                    src={item.img}
                    alt="hero"
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SectionSliderBanner;
